const mapLineItem = (lineItem, orderNumber) => {
  if (!lineItem.product) {
    console.log(
      `Missing product information while requesting Returns line item for order ${orderNumber}`
    );
    return {
      displayName: "",
      imageSrc: "",
      quantity: lineItem.quantity,
      sku: lineItem.sku,
      lineItemNumber: lineItem.lineItemNumber,
      isReturnable: lineItem.isReturnable
    };
  }
  const { product } = lineItem;
  return {
    displayName: product.displayName,
    imageSrc: product.media.images.length ? product.media.images[0]?.url : void 0,
    quantity: lineItem.quantity,
    sku: product.sku,
    lineItemNumber: lineItem.lineItemNumber,
    isReturnable: lineItem.isReturnable
  };
};
const mapReturn = {
  /**
   * Maps base return data common to all views
   * @param data - Return fragment from GraphQL
   * @returns Base return data
   */
  toBase: (data) => ({
    status: data.status,
    returnLabelUrl: data.returnLabelUrl,
    orderNumber: data.order.orderNumber
  }),
  /**
   * Maps return data for select items page view
   * Includes full line items list with product details
   * @param data - Return fragment from GraphQL
   * @returns Return data with line items
   */
  toSelectItemsView: (data) => {
    const filteredLineItems = data.order.lineItems.filter((item) => item.sku || item.product?.sku);
    return {
      ...mapReturn.toBase(data),
      lineItems: filteredLineItems.map((lineItem) => mapLineItem(lineItem, data.order.orderNumber))
    };
  },
  /**
   * Maps return data for confirmation page view
   * Includes return info with items that were returned
   * @param data - Return fragment from GraphQL
   * @returns Return data with return info
   */
  toConfirmationView: (data) => {
    const returnInfo = data.order.returnInfo?.map((info) => ({
      orderNumber: data.order.orderNumber,
      items: info.items.map((item) => ({
        comment: item.comment,
        quantity: item.quantity,
        lineItem: mapLineItem(item.lineItem, data.order.orderNumber)
      })),
      returnDate: info.returnDate,
      returnTrackingId: info.returnTrackingId
    })) || [];
    return {
      ...mapReturn.toBase(data),
      returnInfo
    };
  }
};
export {
  mapReturn
};
//# sourceMappingURL=return-mapper.js.map
